// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Modal$ReactHooksTemplate = require("../../surveys/Modal.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var ChartId$ReactHooksTemplate = require("./chartId.res.js");
var Filters$ReactHooksTemplate = require("../filters/filters.res.js");
var Loading$ReactHooksTemplate = require("./Loading.res.js");
var Dashboard$ReactHooksTemplate = require("./dashboard.res.js");
var HtmlToPdf$ReactHooksTemplate = require("./htmlToPdf.res.js");
var DateFilter$ReactHooksTemplate = require("../filters/dateFilter.res.js");
var ChartComponent$ReactHooksTemplate = require("./ChartComponent.res.js");
var DashboardShare$ReactHooksTemplate = require("./dashboardShare.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../../common/MultipleSelectBox.res.js");
var DashboardShareForm$ReactHooksTemplate = require("./DashboardShareForm.res.js");
var BreadCrumbsComponent$ReactHooksTemplate = require("../breadcrumbs/BreadCrumbsComponent.res.js");

var initialState = {
  loading: true,
  charts: undefined,
  toggleFilter: false,
  enlargedChart: undefined,
  dateRange: undefined,
  shareDetails: /* [] */0,
  showShareModal: false,
  showExportRenderTree: false,
  isPageInteractionLocked: false,
  lockMessage: "Preparing download..."
};

function reducer(state, x) {
  if (typeof x !== "object") {
    switch (x) {
      case "FetchChartsInProgress" :
          return {
                  loading: true,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      case "ToggleFilter" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: !state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      case "ToggleShareModal" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: !state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      
    }
  } else {
    switch (x.TAG) {
      case "FetchChartsCompleted" :
          return {
                  loading: false,
                  charts: x._0,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      case "UpdateDateRange" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: x._0,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      case "SetShareDetails" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: x._0,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      case "EnlargeChart" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: x._0,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      case "SetExportRenderTree" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: x._0,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: state.lockMessage
                };
      case "SetPageInteractionLocked" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: x._0,
                  lockMessage: state.lockMessage
                };
      case "SetLockMessage" :
          return {
                  loading: state.loading,
                  charts: state.charts,
                  toggleFilter: state.toggleFilter,
                  enlargedChart: state.enlargedChart,
                  dateRange: state.dateRange,
                  shareDetails: state.shareDetails,
                  showShareModal: state.showShareModal,
                  showExportRenderTree: state.showExportRenderTree,
                  isPageInteractionLocked: state.isPageInteractionLocked,
                  lockMessage: x._0
                };
      
    }
  }
}

function DashboardComponent(props) {
  var currentRef = props.currentRef;
  var breadCrumbs = props.breadCrumbs;
  var onDashboardChange = props.onDashboardChange;
  var onClick = props.onClick;
  var drillDownChartDetails = props.drillDownChartDetails;
  var dashboards = props.dashboards;
  var dashboard = props.dashboard;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var fetchVisualizations = function (param) {
    Curry._1(dispatch, "FetchChartsInProgress");
    return Js_promise.$$catch((function (error) {
                  console.log(error);
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchChartsCompleted",
                                  _0: undefined
                                }));
                }), Js_promise.then_((function (xs) {
                      return Promise.resolve((setTimeout((function (param) {
                                          Curry._1(dispatch, {
                                                TAG: "FetchChartsCompleted",
                                                _0: xs
                                              });
                                        }), Utils$ReactHooksTemplate.timeout), undefined));
                    }), Js_promise.then_((function (xs) {
                          Js_promise.then_((function (dateRange) {
                                  return Promise.resolve(Curry._1(dispatch, {
                                                  TAG: "UpdateDateRange",
                                                  _0: Caml_option.some(dateRange)
                                                }));
                                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/filters/date_range", DateFilter$ReactHooksTemplate.fromJson));
                          return Promise.resolve(xs);
                        }), Js_promise.then_((function (xs) {
                              console.log(xs);
                              return Promise.resolve(xs);
                            }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/dashboards/" + (String(Dashboard$ReactHooksTemplate.id(currentRef)) + "/visualizations"), ChartId$ReactHooksTemplate.fromJson)))));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (param) {
                  return Js_promise.then_((function (shares) {
                                return Promise.resolve((console.log(shares), Curry._1(dispatch, {
                                                  TAG: "SetShareDetails",
                                                  _0: shares
                                                })));
                              }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/dashboards/" + (String(Dashboard$ReactHooksTemplate.id(currentRef)) + "/shares"), (function (json) {
                                    return Json_decode.field("dashboard_shares", (function (param) {
                                                  return Json_decode.list(DashboardShare$ReactHooksTemplate.decode, param);
                                                }), json);
                                  })));
                }), fetchVisualizations());
        }), [currentRef]);
  var onApplyFilter = function (param) {
    fetchVisualizations();
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  var dashboardSelectBox = function (param) {
    return JsxRuntime.jsxs("details", {
                children: [
                  JsxRuntime.jsx("summary", {
                        children: $$Array.of_list(List.map((function (x) {
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        className: Dashboard$ReactHooksTemplate.name(x) !== Dashboard$ReactHooksTemplate.name(dashboard) ? "hidden" : "h-8 w-8 mr-2",
                                                        src: Image$ReactHooksTemplate.dashboardIcon
                                                      }),
                                                  JsxRuntime.jsx("input", {
                                                        className: "font-semibold text-lg text-charcoal mr-3",
                                                        id: String(Dashboard$ReactHooksTemplate.id(x)),
                                                        title: Dashboard$ReactHooksTemplate.name(x),
                                                        checked: Dashboard$ReactHooksTemplate.name(x) === Dashboard$ReactHooksTemplate.name(dashboard),
                                                        name: "item",
                                                        type: "radio"
                                                      })
                                                ],
                                                className: "flex items-center"
                                              }, String(Dashboard$ReactHooksTemplate.id(x)));
                                  }), dashboards)),
                        className: "flex radios"
                      }),
                  JsxRuntime.jsx("ul", {
                        children: $$Array.of_list(List.map((function (x) {
                                    return JsxRuntime.jsx("li", {
                                                children: JsxRuntime.jsx("label", {
                                                      children: Dashboard$ReactHooksTemplate.name(x),
                                                      htmlFor: Dashboard$ReactHooksTemplate.name(x),
                                                      value: Dashboard$ReactHooksTemplate.name(x),
                                                      onClick: (function (param) {
                                                          var dashboardName = Dashboard$ReactHooksTemplate.name(x);
                                                          var dashboardId = Dashboard$ReactHooksTemplate.id(x);
                                                          var selectedDashboard = List.find((function (y) {
                                                                  return Dashboard$ReactHooksTemplate.name(y) === dashboardName;
                                                                }), dashboards);
                                                          Curry._1(onDashboardChange, selectedDashboard);
                                                          RescriptReactRouter.push("/dashboard/" + String(dashboardId));
                                                        })
                                                    }),
                                                className: "flex"
                                              }, String(Dashboard$ReactHooksTemplate.id(x)));
                                  }), dashboards)),
                        className: "list"
                      })
                ],
                className: "custom-select"
              });
  };
  var handleDownloadOption = function (option) {
    switch (option) {
      case "Export Dashboard (Current View)" :
          if (state.isPageInteractionLocked) {
            return ;
          }
          var element = Belt_Option.getExn(Caml_option.nullable_to_opt(document.querySelector("#dashboard")));
          Curry._1(dispatch, {
                TAG: "SetLockMessage",
                _0: "Preparing dashboard PDF..."
              });
          Curry._1(dispatch, {
                TAG: "SetPageInteractionLocked",
                _0: true
              });
          setTimeout((function (param) {
                  Js_promise.$$catch((function (error) {
                          console.log(error);
                          Curry._1(dispatch, {
                                TAG: "SetPageInteractionLocked",
                                _0: false
                              });
                          return Promise.resolve();
                        }), Js_promise.then_((function (param) {
                              Curry._1(dispatch, {
                                    TAG: "SetPageInteractionLocked",
                                    _0: false
                                  });
                              return Promise.resolve();
                            }), HtmlToPdf$ReactHooksTemplate.generateDashboardPdf(element)));
                }), 30);
          return ;
      case "Export Enlarged Charts" :
          var chartIds = state.charts;
          if (chartIds !== undefined && !(state.isPageInteractionLocked || Belt_List.length(chartIds) === 0)) {
            Curry._1(dispatch, {
                  TAG: "SetLockMessage",
                  _0: "Preparing enlarged charts..."
                });
            Curry._1(dispatch, {
                  TAG: "SetPageInteractionLocked",
                  _0: true
                });
            Curry._1(dispatch, {
                  TAG: "SetExportRenderTree",
                  _0: true
                });
            setTimeout((function (param) {
                    Js_promise.$$catch((function (error) {
                            console.log(error);
                            Curry._1(dispatch, {
                                  TAG: "SetExportRenderTree",
                                  _0: false
                                });
                            Curry._1(dispatch, {
                                  TAG: "SetPageInteractionLocked",
                                  _0: false
                                });
                            return Promise.resolve();
                          }), Js_promise.then_((function (param) {
                                Curry._1(dispatch, {
                                      TAG: "SetExportRenderTree",
                                      _0: false
                                    });
                                Curry._1(dispatch, {
                                      TAG: "SetPageInteractionLocked",
                                      _0: false
                                    });
                                return Promise.resolve();
                              }), HtmlToPdf$ReactHooksTemplate.generateEnlargedChartsPdf(".pdf-chart-page")));
                  }), 50);
            return ;
          } else {
            return ;
          }
      default:
        return ;
    }
  };
  var chartId = state.enlargedChart;
  var tmp;
  if (chartId !== undefined) {
    var chartId$1 = Caml_option.valFromOption(chartId);
    tmp = JsxRuntime.jsx(Modal$ReactHooksTemplate.make, {
          show: true,
          children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                      chartId: chartId$1,
                      drillDownChartDetails: drillDownChartDetails,
                      onClick: onClick,
                      onEnlarge: (function (param) {
                          Curry._1(dispatch, {
                                TAG: "EnlargeChart",
                                _0: Caml_option.some(chartId$1)
                              });
                        }),
                      enlarged: true
                    }, String(ChartId$ReactHooksTemplate.id(chartId$1))),
                className: "w-screen bg-white pt-6 pb-10"
              }),
          handleClose: (function (param) {
              Curry._1(dispatch, {
                    TAG: "EnlargeChart",
                    _0: undefined
                  });
            })
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  var tmp$1;
  if (state.loading) {
    tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                img: Caml_option.some(Image$ReactHooksTemplate.dashboardLoading),
                text: "Loading Charts"
              }),
          className: "h-screen w-full"
        });
  } else {
    var chartIds = state.charts;
    var tmp$2;
    if (state.showExportRenderTree) {
      var chartIds$1 = state.charts;
      var tmp$3;
      if (chartIds$1 !== undefined) {
        var scoreCardChartIds = Belt_List.keep(chartIds$1, (function (xs) {
                return ChartId$ReactHooksTemplate.visualizationType(xs) === "ScoreCard";
              }));
        var otherChartIds = Belt_List.keep(chartIds$1, (function (xs) {
                return ChartId$ReactHooksTemplate.visualizationType(xs) !== "ScoreCard";
              }));
        tmp$3 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                Belt_List.length(scoreCardChartIds) > 0 ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: $$Array.of_list(Belt_List.map(scoreCardChartIds, (function (chartId) {
                                          return JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                                                      chartId: chartId,
                                                      drillDownChartDetails: drillDownChartDetails,
                                                      onClick: onClick,
                                                      onEnlarge: (function (param) {
                                                          
                                                        }),
                                                      scoreCard: true,
                                                      enlarged: true,
                                                      forPdf: true
                                                    }, String(ChartId$ReactHooksTemplate.id(chartId)));
                                        }))),
                              className: "flex flex-wrap gap-4"
                            }),
                        className: "pdf-chart-page bg-white p-6 w-full"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                $$Array.of_list(Belt_List.map(otherChartIds, (function (chartId) {
                            return JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                                              chartId: chartId,
                                              drillDownChartDetails: drillDownChartDetails,
                                              onClick: onClick,
                                              onEnlarge: (function (param) {
                                                  
                                                }),
                                              enlarged: true,
                                              forPdf: true
                                            }, String(ChartId$ReactHooksTemplate.id(chartId))),
                                        className: "pdf-chart-page bg-white p-6 w-full"
                                      }, String(ChartId$ReactHooksTemplate.id(chartId)) + "-pdf");
                          })))
              ]
            });
      } else {
        tmp$3 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
      }
      tmp$2 = JsxRuntime.jsx("div", {
            children: tmp$3,
            "aria-hidden": true,
            className: "fixed pointer-events-none opacity-0",
            style: {
              left: "-10000px",
              top: "0px",
              width: "1400px"
            }
          });
    } else {
      tmp$2 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
    tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  List.length(breadCrumbs) > 1 ? JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(BreadCrumbsComponent$ReactHooksTemplate.make, {
                                                breadCrumbs: breadCrumbs,
                                                breadCrumbsOnClick: props.breadCrumbsOnClick
                                              }),
                                          className: "flex justify-between items-center"
                                        }) : dashboardSelectBox(),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("button", {
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        className: "h-14-px w-14-px",
                                                        src: Image$ReactHooksTemplate.share
                                                      }),
                                                  "Share"
                                                ],
                                                className: "inline-flex h-40-px items-center gap-2 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-charcoal hover:bg-ghostwhite focus:outline-none",
                                                id: "share",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, "ToggleShareModal");
                                                  })
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: state.isPageInteractionLocked ? JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                className: "h-4 w-4 rounded-full border-2 border-palatinateblue border-t-transparent animate-spin shrink-0"
                                                              }),
                                                          JsxRuntime.jsx("span", {
                                                                children: "Preparing...",
                                                                className: "text-sm font-medium text-gray-700 truncate"
                                                              })
                                                        ],
                                                        className: "w-190-px shrink-0 rounded-md border border-gray-300 bg-white px-3 py-0 text-charcoal h-40-px font-medium flex items-center gap-2"
                                                      }) : JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                        options: {
                                                          hd: "Export Dashboard (Current View)",
                                                          tl: {
                                                            hd: "Export Enlarged Charts",
                                                            tl: /* [] */0
                                                          }
                                                        },
                                                        placeholder: "Export as PDF",
                                                        placeholderClassName: "mr-1 text-sm font-medium",
                                                        handleChange: handleDownloadOption,
                                                        selectedOptions: /* [] */0,
                                                        className: "w-190-px shrink-0 rounded-md border border-gray-300 bg-white px-3 py-0 text-charcoal outline-none h-40-px font-medium",
                                                        optionsHoverColor: "text-charcoal hover:bg-ghostwhite hover:text-charcoal ",
                                                        listBoxCss: "mt-1 bg-white border border-gray-300 shadow-xl overflow-hidden divide-y divide-gray-300 ",
                                                        closeOnScroll: true,
                                                        menuZIndexClass: "z-30"
                                                      }),
                                                id: "pdf_download"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                                                            onClose: toggleFilter,
                                                            onApply: onApplyFilter,
                                                            showDateFilter: true,
                                                            showFilterPills: false
                                                          }),
                                                      className: "capitalize tracking-wide"
                                                    }),
                                                className: "bg-white"
                                              })
                                        ],
                                        className: "flex items-center gap-2"
                                      })
                                ],
                                className: "flex justify-between items-center p-16-px border border-gray-300 rounded-lg bg-white mb-4"
                              }),
                          JsxRuntime.jsx("div", {
                                children: chartIds !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                children: "Active Filters",
                                                                className: "flex items-center font-normal text-sm h-8"
                                                              }),
                                                          JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                                                                onClose: toggleFilter,
                                                                onApply: onApplyFilter,
                                                                showDateFilter: false,
                                                                showFilterPills: true
                                                              })
                                                        ],
                                                        className: "flex flex-wrap gap-2"
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsxs("button", {
                                                              children: [
                                                                JsxRuntime.jsx("img", {
                                                                      className: "h-14-px mr-2-px",
                                                                      src: Image$ReactHooksTemplate.filterButton
                                                                    }),
                                                                "Filters"
                                                              ],
                                                              className: "bg-ghostwhite border border-gray-400 focus:outline-none\n                              shadow-inner flex rounded py-2 px-3 text-xs w-20",
                                                              id: "filters",
                                                              onClick: (function (param) {
                                                                  Curry._1(dispatch, "ToggleFilter");
                                                                })
                                                            }),
                                                        className: "float-right"
                                                      })
                                                ],
                                                className: "px-16-px flex justify-between"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: $$Array.of_list(Belt_List.map(Belt_List.keep(chartIds, (function (xs) {
                                                                return ChartId$ReactHooksTemplate.visualizationType(xs) === "ScoreCard";
                                                              })), (function (chartId) {
                                                            return JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                                                                        chartId: chartId,
                                                                        drillDownChartDetails: drillDownChartDetails,
                                                                        onClick: onClick,
                                                                        onEnlarge: (function (param) {
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "EnlargeChart",
                                                                                  _0: Caml_option.some(chartId)
                                                                                });
                                                                          }),
                                                                        scoreCard: true
                                                                      }, String(ChartId$ReactHooksTemplate.id(chartId)));
                                                          }))),
                                                className: "flex flex-wrap p-16-px gap-4"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: $$Array.of_list(Belt_List.map(Belt_List.keep(chartIds, (function (xs) {
                                                                return ChartId$ReactHooksTemplate.visualizationType(xs) !== "ScoreCard";
                                                              })), (function (chartId) {
                                                            return JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                                                                        chartId: chartId,
                                                                        drillDownChartDetails: drillDownChartDetails,
                                                                        onClick: onClick,
                                                                        onEnlarge: (function (param) {
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "EnlargeChart",
                                                                                  _0: Caml_option.some(chartId)
                                                                                });
                                                                          })
                                                                      }, String(ChartId$ReactHooksTemplate.id(chartId)));
                                                          }))),
                                                className: "flex flex-wrap p-16-px"
                                              })
                                        ]
                                      }) : "No Charts Loaded for the Dashboard"
                              })
                        ]
                      }),
                  id: "dashboard"
                }),
            state.showShareModal ? JsxRuntime.jsx(DashboardShareForm$ReactHooksTemplate.make, {
                    dashboard: dashboard,
                    dashboardShares: state.shareDetails,
                    onClose: (function (param) {
                        Curry._1(dispatch, "ToggleShareModal");
                      })
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
            tmp$2
          ]
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                tmp,
                JsxRuntime.jsxs("div", {
                      children: [
                        state.toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                                onClose: toggleFilter,
                                onApply: onApplyFilter,
                                showDateFilter: false,
                                showFilterPills: false
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        tmp$1
                      ],
                      className: state.isPageInteractionLocked ? "pointer-events-none select-none" : ""
                    }),
                state.isPageInteractionLocked ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                className: "absolute inset-0 bg-charcoal",
                                style: {
                                  backdropFilter: "blur(2px)",
                                  opacity: "0.35"
                                }
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("div", {
                                                          className: "h-5 w-5 rounded-full border-2 border-white border-t-transparent animate-spin"
                                                        }),
                                                    className: "h-10 w-10 rounded-full bg-palatinateblue flex items-center justify-center shrink-0"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Downloading PDF",
                                                            className: "text-sm font-semibold text-charcoal"
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: state.lockMessage,
                                                            className: "text-xs text-gray-600 truncate"
                                                          })
                                                    ],
                                                    className: "min-w-0"
                                                  })
                                            ],
                                            className: "flex items-center gap-3"
                                          }),
                                      className: "w-360-px max-w-[92vw] bg-white border border-gray-200 rounded-xl px-4 py-4 shadow-2xl"
                                    }),
                                className: "relative w-full h-full flex items-center justify-center"
                              })
                        ],
                        className: "fixed top-0 left-0 w-full h-screen z-50"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ]
            });
}

var make = DashboardComponent;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
